<div ngForm="ewVideoSetingsForm" class="form-horizontal">
	<vb-ui-horizontal-form-group>
		<label for="ewVideoSource" #uiLabel>{{ 'Device_VideoSource' | translate }}</label>
		<vb-ui-select uiControl>
			<select #selectElement id="ewVideoSource" name="videoSourceOptions" #ewVideoSource="ngModel" [(ngModel)]="webcast.videoSource" (ngModelChange)="updateVideoSource()" required>
				<option *ngFor="let source of availableSources" [ngValue]="source.value">
					{{ source.label }}
				</option>
			</select>
		</vb-ui-select>
		<div *ngIf="ewVideoSource.invalid" role="alert" vbUiErrorMessage uiValidation>
			@if (ewVideoSource.errors.required) {
				{{ 'ThisFieldIsRequired' | translate }}
			} @else if (ewVideoSource.errors.sourceOptionNotAvailable) {
				{{ 'Event_VideoSourceOptionNotAvailable' | translate }}
			}
		</div>
	</vb-ui-horizontal-form-group>
	<vb-ui-horizontal-form-group *ngIf="webcast.videoSource === WebcastVideoSource.PRESENTATION">
		<label #uiLabel></label>
		<presentation-profile-grid-input uiControl name="presentationProfile" #ewPesentationProfile="ngModel" [required]="webcast.videoSource === WebcastVideoSource.PRESENTATION" [(ngModel)]="webcast.presentationProfileId" [webcastId]="webcast.id" [startDate]="webcast.startDate" [preProductionDurationMs]="webcast.preProduction?.durationMs" [endDate]="webcast.endDate" [externalErrors]="externalErrors" (presentationProfileSelected)="onPresentationProfileChange($event.profile)">
		</presentation-profile-grid-input>
		<div *ngIf="ewPesentationProfile.invalid" role="alert" vbUiErrorMessage uiValidation>
			@if (ewPesentationProfile.errors.required) {
				{{ 'ThisFieldIsRequired' | translate }}
			} @else if (ewPesentationProfile.errors.presentationProfileConflict) {
				{{ 'Event_PresentationProfileNotAvailable' | translate }}
			}
		</div>
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group *ngIf="webcast.videoSource === WebcastVideoSource.SIP_ADDRESS">
		<label #uiLabel></label>
		<input uiControl type="email" class="form-control" name="videoSourceSipAddress" [attr.aria-label]="'Media_Recording_Form_Video_PlaceholderURI' | translate" autocomplete="off" [placeholder]="'Media_Recording_Form_Video_PlaceholderURI' | translate" [(ngModel)]="webcast.vcSipAddress" #ewVideoSourceSipAddress="ngModel" role="combobox" [typeahead]="sipAddresses$" [typeaheadAsync]="true" [typeaheadMinLength]="0" typeaheadOptionField="sipAddress" [typeaheadWaitMs]="500" [required]="webcast.videoSource === WebcastVideoSource.SIP_ADDRESS" [vbEmail]="webcast.videoSource === WebcastVideoSource.SIP_ADDRESS"/>

		<div *ngIf="ewVideoSourceSipAddress.invalid" role="alert" vbUiErrorMessage uiValidation>
			@if (ewVideoSourceSipAddress.errors.required) {
				{{ 'ThisFieldIsRequired' | translate }}
			} @else if (ewVideoSourceSipAddress.errors.vbEmail) {
				{{ 'Event_Webcast_Video_ValidAddress' | translate }}
			}
		</div>
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group *ngIf="webcast.videoSource === WebcastVideoSource.PEXIP">
		<label #uiLabel></label>
		<div uiControl>
			<input uiControl type="email" class="form-control" name="videoSourceSipAddress" [attr.aria-label]="'Media_Recording_Form_Pexip_Video_PlaceholderURI' | translate" autocomplete="off" [placeholder]="'Media_Recording_Form_Pexip_Video_PlaceholderURI' | translate" [(ngModel)]="webcast.vcSipAddress" #ewVideoSourceSipAddress="ngModel" role="combobox" [typeahead]="sipAddresses$" [typeaheadAsync]="true" [typeaheadMinLength]="0" typeaheadOptionField="sipAddress" [typeaheadWaitMs]="500" [required]="webcast.videoSource === WebcastVideoSource.PEXIP" [vbEmail]="webcast.videoSource === WebcastVideoSource.PEXIP"/>

			<div *ngIf="ewVideoSourceSipAddress.invalid" role="alert" vbUiErrorMessage uiValidation>
				@if (ewVideoSourceSipAddress.errors.required) {
					{{ 'ThisFieldIsRequired' | translate }}
				} @else if (ewVideoSourceSipAddress.errors.vbEmail) {
					{{ 'Event_Webcast_Video_ValidAddress' | translate }}
				}
			</div>
			<div [ngClass]="styles.helpBlock">{{ 'Media_Recording_Form_Pexip_Video_Help_Text' | translate }}</div>
		</div>
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group *ngIf="webcast.videoSource === WebcastVideoSource.MSTEAMS">
		<label #uiLabel></label>
		<textarea uiControl autofocus rows="5" [required]="webcast.videoSource === WebcastVideoSource.MSTEAMS" name="videoSourceMSTeams" [attr.aria-label]="'Microsoft_Teams_Meeting_Url' | translate" [placeholder]="'Microsoft_Teams_Meeting_Url' | translate" [(ngModel)]="webcast.vcMicrosoftTeamsMeetingUrl" #videoSourceMSTeams="ngModel" vbUiUrl vbUiTextArea></textarea>
		<div *ngIf="videoSourceMSTeams.invalid" role="alert" vbUiErrorMessage uiValidation>
			@if (videoSourceMSTeams.errors.required) {
				{{ 'ThisFieldIsRequired' | translate }}
			} @else if (videoSourceMSTeams.errors.vbUrl) {
				{{ 'Microsoft_Teams_Meeting_Url_Label' | translate }}
			} @else if (videoSourceMSTeams.errors.microsoftTeamsTenantIdRequired) {
				{{ 'Microsoft_Teams_TenantIdRequired' | translate }}
			}
		</div>
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group *ngIf="webcast.videoSource === WebcastVideoSource.VOD">
		<label id="vodSource" #uiLabel>
			{{ 'Event_Webcast_Vod_Label' | translate }}
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Webcast_Vod_Tooltip' | translate">
			</vb-ui-tooltip>
		</label>
		<vb-ui-video-preview-select uiControl [attr.aria-label]="vodSource" class="vb-input-field" name="vodVideoSource" #vodVideoSource="ngModel" [(ngModel)]="webcast.vodInfo" (ngModelChange)="updateVodErrors()" [required]="webcast.videoSource === WebcastVideoSource.VOD" [searchQuery]="videoSearchLoader">
		</vb-ui-video-preview-select>
		<div uiValidation>
			<div *ngIf="vodVideoSource.invalid" role="alert" vbUiErrorMessage>
				@if (vodVideoSource.errors.required) {
					{{ 'ThisFieldIsRequired' | translate }}
				}
			</div>
			<div vbUiErrorMessage *ngIf="showVodDurationError">
				{{ 'Event_Webcast_Vod_DurationWarning' | translate }}
			</div>
		</div>
	</vb-ui-horizontal-form-group>

	<div *ngIf="webcast.videoSource === WebcastVideoSource.SIP_ADDRESS ||
		webcast.videoSource === WebcastVideoSource.PEXIP ||
		webcast.videoSource === WebcastVideoSource.ZOOM">
		<vb-ui-horizontal-form-group *ngIf="webcast.videoSource !== WebcastVideoSource.ZOOM">
			<label #uiLabel>{{ 'DTMF_Pin' | translate }}</label>
			<div uiControl>
				<input type="text" name="dtmfPin" class="form-control" [pattern]="DTMF_CODES_REGEX" [(ngModel)]="webcast.vcSipPin" #dtmfPinControl="ngModel">
				<label class="control-label">{{ 'DTMF_PinLabel' | translate }}</label>
			</div>
			<div *ngIf="dtmfPinControl.touched && dtmfPinControl.invalid" role="alert" vbUiErrorMessage uiValidation>
				<label *ngIf="dtmfPinControl.errors.pattern">
					{{ 'DTMF_PinError' | translate }}
				</label>
			</div>
		</vb-ui-horizontal-form-group>

		<vb-ui-horizontal-form-group>
			<label #uiLabel>{{ 'DTMF_InitialCodes' | translate }}</label>
			<div uiControl>
				<input type="text" name="dtmfCodes" class="form-control" [pattern]="DTMF_CODES_REGEX" [(ngModel)]="webcast.vcDtmf" #dtmfCodesControl="ngModel">
				<label class="control-label">{{ 'DTMF_InitialCodesLabel' | translate }}</label>
			</div>
			<div *ngIf="dtmfCodesControl.touched && dtmfCodesControl.pattern" role="alert" vbUiErrorMessage uiValidation>
				<label *ngIf="dtmfCodesControl.errors.vbDtmf">
					{{ 'DTMF_InitialCodesError' | translate }}
				</label>
			</div>
		</vb-ui-horizontal-form-group>

		<vb-ui-horizontal-form-group>
			<label id="ewDTMFLabel" #uiLabel>{{ 'DTMF_EnableControl' | translate }}</label>
			<div uiControl>
				<div vbUiRadioBtnGroup aria-labelledby="ewDTMFLabel">
					<button role="radio" name="enabledDtmfControls" class="btn btn-admin btn-white" [vbUiRadioBtn]="true" [activeClass]="'active'" [notThemed]="true" [(ngModel)]="webcast.vcDtmfControlsEnabled" type="button">
						{{ 'Enabled' | translate }}
					</button>
					<button role="radio" name="enabledDtmfControls" class="btn btn-admin btn-white" [vbUiRadioBtn]="false" [activeClass]="'active'" [notThemed]="true" [(ngModel)]="webcast.vcDtmfControlsEnabled" type="button">
						{{ 'Disabled' | translate }}
					</button>
				</div>
				<label class="help-block">{{ 'DTMF_EnableControlLabel' | translate }}</label>
			</div>
		</vb-ui-horizontal-form-group>
	</div>

	<vb-ui-horizontal-form-group [hidden]="!showAutomatedWebcast">
		<label #uiLabel id="ewAutomatedWebcast">{{ 'Event_AutomatedWebcast' | translate }}
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_AutomatedWebcast_Tooltip' | translate">
			</vb-ui-tooltip>
		</label>
		<div uiControl vbUiRadioBtnGroup aria-labelledby="ewAutomatedWebcast">
			<button type="button" class="btn btn-admin btn-white" name="automatedWebcastTrue" #automatedWebcastTrue="ngModel" [(ngModel)]="webcast.automatedWebcast" (ngModelChange)="validateAutomatedWebcast()" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
				{{ 'UI_Enabled' | translate }}
			</button>
			<button type="button" class="btn btn-admin btn-white margin-right-10" name="automatedWebcastFalse" [(ngModel)]="webcast.automatedWebcast" (ngModelChange)="validateAutomatedWebcast()" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
				{{ 'UI_Disabled' | translate }}
			</button>
			<span *ngIf="webcast.automatedWebcast && webcast.videoSource === WebcastVideoSource.SIP_ADDRESS" class="help-block box-inline-block">{{ 'Event_AutomatedWebcast_VideoAddress_Help' | translate }}</span>
		</div>
		<div role="alert" vbUiErrorMessage uiControl *ngIf="automatedWebcastTrue.invalid && automatedWebcastTrue.errors.automatedDateInPast">
			{{ 'Event_AutomatedWebcast_StartInPast' | translate }}
		</div>
	</vb-ui-horizontal-form-group>

	<rtmp-video-source-details *ngIf="webcast.videoSource === WebcastVideoSource.RTMP || webcast.videoSource === WebcastVideoSource.SRT" name="rtmpVideoSourceDetails" [webcastId]="webcast.id" [(ngModel)]="webcast.rtmpSettings" [startDate]="webcast.startDate" [webcastType]="webcast.videoSource" [endDate]="webcast.endDate" [preProductionDurationMs]="webcast.preProduction?.durationMs" [features]="features" [issue]="rtmpVideoSourceIssue">
	</rtmp-video-source-details>
	<vb-ui-horizontal-form-group>
		<label id="ewAutoplay" #uiLabel>
			{{ 'Media_Autoplay' | translate }}
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Webcast_AutoplayHelp' | translate">
			</vb-ui-tooltip>
		</label>
		<div uiControl>
			<div uiControl vbUiRadioBtnGroup aria-labelledby="ewAutoplay">
				<button type="button" class="btn btn-admin btn-white" name="autoplay" [(ngModel)]="webcast.autoplay" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
					{{ 'UI_Enabled' | translate }}
				</button>
				<button type="button" name="autoplay" class="btn btn-admin btn-white margin-right-10" [(ngModel)]="webcast.autoplay" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
					{{ 'UI_Disabled' | translate }}
				</button>
			</div>
		</div>
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group *ngIf="webcast.videoSource === WebcastVideoSource.PRESENTATION">
		<label id="ewClosedCaptions" #uiLabel>{{ 'Event_ClosedCaptions' | translate }}</label>
		<div uiControl aria-labelledby="ewClosedCaptions" vbUiRadioBtnGroup>
			<button type="button" class="btn btn-admin btn-white" name="ewClosedCaption" [(ngModel)]="webcast.closedCaptionsEnabled" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
				{{ 'UI_Enabled' | translate }}
			</button>
			<button type="button" class="btn btn-admin btn-white" name="ewClosedCaption" [(ngModel)]="webcast.closedCaptionsEnabled" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
				{{ 'UI_Disabled' | translate }}
			</button>
		</div>
	</vb-ui-horizontal-form-group>

	<!-- Webex Teams Source -->
	<vb-ui-horizontal-form-group *ngIf="webcast.videoSource === WebcastVideoSource.WEBEX">
		<label #uiLabel>{{ 'Media_Videos_Sharing_Spark_SelectRoom' | translate }}</label>

		<div uiControl>
			<p [hidden]="!webcast.webexTeam" [ngClass]="styles.selectedTeam">{{ 'Media_Videos_Webex_Teams_CurrentSpace' | translate }}: <strong>{{ webcast.webexTeam?.name }}</strong>
				<a role="button" uiSref="void" (click)="showWebexTeams = !showWebexTeams">
					<span class="glyphicons edit padding-left-10"></span>
				</a>
			</p>
			<webex-teams name="webexTeam" [hidden]="webcast.webexTeam && !showWebexTeams" #ewWebexTeam="ngModel" [(ngModel)]="webcast.webexTeam" [required]="webcast.videoSource === WebcastVideoSource.WEBEX">
			</webex-teams>
		</div>
		<div role="alert" vbUiErrorMessage uiValidation *ngIf="ewWebexTeam.invalid">
			@if (ewWebexTeam.errors.required) {
				{{ 'ThisFieldIsRequired' | translate }}
			}
		</div>
	</vb-ui-horizontal-form-group>

	<edit-webcast-zoom-input *ngIf="webcast.videoSource === WebcastVideoSource.ZOOM" name="ewZoomInput" ngModel ngDefaultControl [(webcast)]="webcast">
	</edit-webcast-zoom-input>

	<live-subtitles *ngIf="(enableLiveSubtitles$ | async)" [liveSubtitles]="webcast.liveSubtitles" [videoSource]="webcast.videoSource" [issue]="subtitleIssue" [sourceLanguages]="TranscriptionLanguagesService.liveLanguages" [translationLanguages]="TranscriptionLanguagesService.aiServiceTranslationLanguages" (subtitlesChanged)="updateLiveSubtitles($event)" (validated)="validateVideoSettingsForm($event, 'liveSubtitlesError')">
	</live-subtitles>
	<input type="hidden" name="videoSettingsFormHidden" ngModel/>
</div>
